// circular with Layer
/** @internal */
export const TypeId = /*#__PURE__*/Symbol.for("effect/ManagedRuntime");
//# sourceMappingURL=circular.js.map